import * as type from '../types/question_category';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var requestQuestionCategoryList = actionCreator(type.REQUEST_QUESTION_CATEGORY_LIST);
export var successQuestionCategoryList = actionCreator(type.SUCCESS_QUESTION_CATEGORY_LIST);
export var failureQuestionCategoryList = actionCreator(type.FAILURE_QUESTION_CATEGORY_LIST);
export var requestQuestionCategoryDetail = actionCreator(type.REQUEST_QUESTION_CATEGORY_DETAIL);
export var successQuestionCategoryDetail = actionCreator(type.SUCCESS_QUESTION_CATEGORY_DETAIL);
export var failureQuestionCategoryDetail = actionCreator(type.FAILURE_QUESTION_CATEGORY_DETAIL);